import styled from "styled-components";
import { cssIf } from "../../utils/styledMixins";

export const FooterButtons = styled.div`
  flex: 1;
  flex-wrap: wrap;
  display: flex;
  justify-content: space-between;
  
  ${cssIf(({center}) => !!center)`
    justify-content: center;
  `}
  
  button:focus-within {
    outline: 1px dotted #212121;
  }

  .button-icon-right {
    margin-right: -10px;
  }
`;